import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// Get products
export const getFabricCuttingList = createAsyncThunk("/getFabricCuttingList", async (data, { rejectWithValue }) => {
//   const token = localStorage.getItem("authToken");

  try {
    const response = await axios.post(`${baseUrl}fabricCutting/api/v1/get-Fabric-CuttingList`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log("Fabric Cutting List response", response);
    return response?.data; 
  } catch (error) {
    console.error("Error fetching Fabric Cutting ", error);

    return rejectWithValue(error.response?.data?.message || "Failed to fetch Fabric Cutting ");
  }
});
